import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IProoductDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProoductDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetStokDetayStokBilgileri: any[];
  GetStokDetayStokBilgileri_dummy: any[];
  GetKullanildigiAraclar: any[];
  GetKullanildigiAraclar_dummy: any[];
  GetAlternatifUrun: any[];
  GetAlternatifUrun_dummy: any[];
  GetTamirTakim: any[];
  GetTamirTakim_dummy: any[];
  GetTeknikOzellikler: any[];
  GetTeknikOzellikler_dummy: any[];
  GetKullanildigiUrunler: any[];
  GetKullanildigiUrunler_dummy: any[];
  DistinctMusteriMarka: any[];
  DistinctMusteriMarka_dummy: any[];
  GetOemBilgileri: any[];
  GetOemBilgileri_dummy: any[];
  GetWebStokOem: any[];
  GetWebStokOem_dummy: any[];
  GetStokResim: any[];
  GetStokResim_dummy: any[];
  GetFarkliOlcuStok: any[];
  GetFarkliOlcuStok_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp67122Visible: "visible" | "hidden";
  isComp9435Visible: "visible" | "hidden";
  isComp583835Visible: "visible" | "hidden";
  isComp711881Visible: "visible" | "hidden";
  isComp721927Visible: "visible" | "hidden";
  isComp536371Visible: "visible" | "hidden";
  isComp206560Visible: "visible" | "hidden";
  isComp203933Visible: "visible" | "hidden";
  isComp397200Visible: "visible" | "hidden";
  isComp801000Visible: "visible" | "hidden";
  isComp720155Visible: "visible" | "hidden";
}

export class ProoductDetail_ScreenBase extends React.PureComponent<
  IProoductDetail_ScreenProps,
  any
> {
  prooductdetail_67122_value_kuikaCarouselRef: React.RefObject<any>;
  prooductdetail_264271_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_102381_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_251456_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_787969_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_79661_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_196525_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_318215_value_kuikaGalleryViewRef: React.RefObject<any>;
  prooductdetail_923301_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 647404,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 67122,
          PropertyName: "nodatafoundmessage",
          Value: "PICTURE NOT FOUND",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 536371,
          PropertyName: "tab",
          Value: "REPAIR KITS",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 206560,
          PropertyName: "tab",
          Value: "PRODUCT USED",
          TagName: "TabItem6_tab",
        },
        {
          Id: 203933,
          PropertyName: "tab",
          Value: "VEHICLES USED",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 397200,
          PropertyName: "tab",
          Value: "SIMILAR PRODUCTS",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 801000,
          PropertyName: "tab",
          Value: "TECHNICAL SPECIFICATIONS",
          TagName: "TabItem4_tab",
        },
        {
          Id: 720155,
          PropertyName: "tab",
          Value: "OTHER OEMS",
          TagName: "TabItem5_tab",
        },
        {
          Id: 721927,
          PropertyName: "label",
          Value: "REQUEST OFFER",
          TagName: "Button5_label",
        },
        {
          Id: 680501,
          PropertyName: "label",
          Value: "ADD TO CART",
          TagName: "Button4_label",
        },
        {
          Id: 617138,
          PropertyName: "label",
          Value: "REVIEW",
          TagName: "Button3_label",
        },
        {
          Id: 241943,
          PropertyName: "label",
          Value: "REVIEW",
          TagName: "Button2_label",
        },
        {
          Id: 531437,
          PropertyName: "label",
          Value: "REVIEW",
          TagName: "Button1_label",
        },
        {
          Id: 45319309,
          PropertyName: "f1e0fbb8-a55c-ede0-d2a4-398c736091a6_notify",
          Value: "CANNOT ADD A PRODUCT TO YOUR CART WITHOUT A PRICE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 647404,
          PropertyName: "placeholder",
          Value: "Vaden No, OEM No, Nom du produit, Marque, Modèle, Véhicule",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 67122,
          PropertyName: "nodatafoundmessage",
          Value: "Image introuvable",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 536371,
          PropertyName: "tab",
          Value: "Kits de réparation",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 206560,
          PropertyName: "tab",
          Value: "Produits associés",
          TagName: "TabItem6_tab",
        },
        {
          Id: 203933,
          PropertyName: "tab",
          Value: "Véhicules compatibles",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 397200,
          PropertyName: "tab",
          Value: "Produits similaires ",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 801000,
          PropertyName: "tab",
          Value: "Spécifications techniques",
          TagName: "TabItem4_tab",
        },
        {
          Id: 720155,
          PropertyName: "tab",
          Value: "Autres OEM",
          TagName: "TabItem5_tab",
        },
        {
          Id: 721927,
          PropertyName: "label",
          Value: "Demander un devis",
          TagName: "Button5_label",
        },
        {
          Id: 680501,
          PropertyName: "label",
          Value: "Ajouter au panier",
          TagName: "Button4_label",
        },
        {
          Id: 617138,
          PropertyName: "label",
          Value: "Consulter",
          TagName: "Button3_label",
        },
        {
          Id: 241943,
          PropertyName: "label",
          Value: "Consulter",
          TagName: "Button2_label",
        },
        {
          Id: 531437,
          PropertyName: "label",
          Value: "Consulter",
          TagName: "Button1_label",
        },
        {
          Id: 9715061,
          PropertyName: "f1e0fbb8-a55c-ede0-d2a4-398c736091a6_notify",
          Value: "Vous ne pouvez pas ajouter au panier un produit sans prix",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 647404,
          PropertyName: "placeholder",
          Value:
            "No.Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 67122,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontró la imagen.",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 536371,
          PropertyName: "tab",
          Value: "Kit de Repuestos",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 206560,
          PropertyName: "tab",
          Value: "Productos utilizados en",
          TagName: "TabItem6_tab",
        },
        {
          Id: 203933,
          PropertyName: "tab",
          Value: "Vehículos Usados",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 397200,
          PropertyName: "tab",
          Value: "Productos Similares",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 801000,
          PropertyName: "tab",
          Value: "Especificaciones Técnicas",
          TagName: "TabItem4_tab",
        },
        {
          Id: 720155,
          PropertyName: "tab",
          Value: "Otros OEM",
          TagName: "TabItem5_tab",
        },
        {
          Id: 721927,
          PropertyName: "label",
          Value: "Solicitar presupuesto",
          TagName: "Button5_label",
        },
        {
          Id: 680501,
          PropertyName: "label",
          Value: "Añadir al carrito",
          TagName: "Button4_label",
        },
        {
          Id: 617138,
          PropertyName: "label",
          Value: "Revisar",
          TagName: "Button3_label",
        },
        {
          Id: 241943,
          PropertyName: "label",
          Value: "Revisar",
          TagName: "Button2_label",
        },
        {
          Id: 531437,
          PropertyName: "label",
          Value: "Revisar",
          TagName: "Button1_label",
        },
        {
          Id: 4579979,
          PropertyName: "f1e0fbb8-a55c-ede0-d2a4-398c736091a6_notify",
          Value: "No se puede añadir un producto sin precio al carrito.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "a8acb592-eb26-44a1-9e49-d73644af2abb",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 647404,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        {
          Id: 67122,
          PropertyName: "nodatafoundmessage",
          Value: "Resim Bulunamadı",
        },
        {
          Id: 264271,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 119578,
          PropertyName: "value",
          Value: "[datafield:musteri_marka]",
        },
        { Id: 986010, PropertyName: "value", Value: "[datafield:oem_no]" },
        {
          Id: 102381,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 727129,
          PropertyName: "value",
          Value: "[datafield:farkli_olcu_stogu]",
        },
        {
          Id: 357695,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 721927, PropertyName: "label", Value: "Teklif Al" },
        { Id: 680501, PropertyName: "label", Value: "Sepete Ekle" },
        { Id: 536371, PropertyName: "tab", Value: "Tamir Takımları" },
        {
          Id: 251456,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 711225, PropertyName: "value", Value: "[datafield:tt_kodu]" },
        {
          Id: 96452,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 531437, PropertyName: "label", Value: "İncele" },
        { Id: 206560, PropertyName: "tab", Value: "Kullanıldığı Ürünler" },
        {
          Id: 787969,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 517755, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        {
          Id: 309510,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 617138, PropertyName: "label", Value: "İncele" },
        { Id: 203933, PropertyName: "tab", Value: "Kullanıldığı Araçlar" },
        {
          Id: 79661,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 97295, PropertyName: "value", Value: "[datafield:marka]" },
        { Id: 557836, PropertyName: "value", Value: "[datafield:model]" },
        { Id: 107346, PropertyName: "value", Value: "[datafield:motor]" },
        { Id: 397200, PropertyName: "tab", Value: "Benzer Ürünler" },
        {
          Id: 196525,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 690845, PropertyName: "value", Value: "[datafield:ana_urun]" },
        {
          Id: 220309,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 241943, PropertyName: "label", Value: "İncele" },
        { Id: 801000, PropertyName: "tab", Value: "Teknik Özellikler" },
        {
          Id: 318215,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 488520,
          PropertyName: "value",
          Value: "[datafield:teknik_aciklama]",
        },
        { Id: 635821, PropertyName: "value", Value: "[datafield:deger]" },
        { Id: 720155, PropertyName: "tab", Value: "Diğer Oemler" },
        {
          Id: 923301,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 441147,
          PropertyName: "value",
          Value: "[datafield:musteri_marka]",
        },
        { Id: 821262, PropertyName: "value", Value: "[datafield:oem_no]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.prooductdetail_647404_value_kuikaTextInputRef = React.createRef();
    this.prooductdetail_67122_value_kuikaCarouselRef = React.createRef();
    this.prooductdetail_264271_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_102381_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_251456_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_787969_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_79661_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_196525_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_318215_value_kuikaGalleryViewRef = React.createRef();
    this.prooductdetail_923301_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      GetLanguage: "",
      GetParametreler: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetStokDetayStokBilgileri: [],
      GetKullanildigiAraclar: [],
      GetAlternatifUrun: [],
      GetTamirTakim: [],
      GetTeknikOzellikler: [],
      GetKullanildigiUrunler: [],
      DistinctMusteriMarka: [],
      GetOemBilgileri: [],
      GetWebStokOem: [],
      GetStokResim: [],
      GetFarkliOlcuStok: [],
      IfThenElse: false,
      isComp67122Visible: "hidden",
      isComp9435Visible: "hidden",
      isComp583835Visible: "hidden",
      isComp711881Visible: "hidden",
      isComp721927Visible: "hidden",
      isComp536371Visible: "hidden",
      isComp206560Visible: "hidden",
      isComp203933Visible: "hidden",
      isComp397200Visible: "hidden",
      isComp801000Visible: "hidden",
      isComp720155Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("prooductdetail", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.prooductDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("prooductdetail", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("prooductdetail", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.prooductDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  prooductDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.prooductDetailPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  prooductDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "prooductDetail/prooductDetailPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp721927Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetKullanici = result?.data.getKullanici;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.prooductDetailPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  prooductDetailPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.prooductDetailPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  prooductDetailPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      stokkod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      FiyatGrup_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiatGrup ?? this.props.screenInputs.fiatgrup,
        "string"
      ),
      CariKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiyati_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.listeFiat ?? this.props.screenInputs.listefiat,
        "string"
      ),
      Dil_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      stokkodu_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      stokKod_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      dil_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      STOK_KODU_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      dil_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      stokkod_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      dil_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      StokKodu_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      dil_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      STOK_KODU_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      stokkod_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      stokkod_9: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      StokKodu_10: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      Tip_10: ReactSystemFunctions.convertToTypeByName(1, "number"),
      stokkodu_11: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      dil_11: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "prooductDetail/prooductDetailPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetStokDetayStokBilgileri =
      result?.data.getStokDetayStokBilgileri;
    formVars.prooductdetail_685473_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].birlesmisstok
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].birlesmisstok
        : null
    );
    formVars.prooductdetail_461242_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].stoK_KODU
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].stoK_KODU
        : null
    );
    formVars.prooductdetail_61661_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[
              stateVars.GetStokDetayStokBilgileri.length - 1
            ].barkoD1
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[
            this.state.GetStokDetayStokBilgileri.length - 1
          ].barkoD1
        : null
    );
    formVars.prooductdetail_651857_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].fiyat
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].fiyat
        : null
    );
    stateVars.isComp583835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].adetBazliFiyatVarMi
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].adetBazliFiyatVarMi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetKullanildigiAraclar = result?.data.getKullanildigiAraclar;

    stateVars.isComp203933Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanildigiAraclar !== undefined
            ? stateVars.GetKullanildigiAraclar?.length > 0
              ? stateVars.GetKullanildigiAraclar[0].marka
              : null
            : this.state.GetKullanildigiAraclar?.length > 0
            ? this.state.GetKullanildigiAraclar[0].marka
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetAlternatifUrun = result?.data.getAlternatifUrun;

    stateVars.isComp397200Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetAlternatifUrun !== undefined
            ? stateVars.GetAlternatifUrun?.length > 0
              ? stateVars.GetAlternatifUrun[0].anA_URUN
              : null
            : this.state.GetAlternatifUrun?.length > 0
            ? this.state.GetAlternatifUrun[0].anA_URUN
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetTamirTakim = result?.data.getTamirTakim;

    stateVars.isComp536371Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTamirTakim !== undefined
            ? stateVars.GetTamirTakim?.length > 0
              ? stateVars.GetTamirTakim[0].stoK_KODU
              : null
            : this.state.GetTamirTakim?.length > 0
            ? this.state.GetTamirTakim[0].stoK_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetTeknikOzellikler = result?.data.getTeknikOzellikler;

    stateVars.isComp801000Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeknikOzellikler !== undefined
            ? stateVars.GetTeknikOzellikler?.length > 0
              ? stateVars.GetTeknikOzellikler[0].tekniK_ACIKLAMA
              : null
            : this.state.GetTeknikOzellikler?.length > 0
            ? this.state.GetTeknikOzellikler[0].tekniK_ACIKLAMA
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetKullanildigiUrunler = result?.data.getKullanildigiUrunler;

    stateVars.isComp206560Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanildigiUrunler !== undefined
            ? stateVars.GetKullanildigiUrunler?.length > 0
              ? stateVars.GetKullanildigiUrunler[0].stoK_KODU
              : null
            : this.state.GetKullanildigiUrunler?.length > 0
            ? this.state.GetKullanildigiUrunler[0].stoK_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.DistinctMusteriMarka = result?.data.distinctMusteriMarka;
    stateVars.GetOemBilgileri = result?.data.getOemBilgileri;

    stateVars.isComp720155Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetOemBilgileri !== undefined
            ? stateVars.GetOemBilgileri?.length > 0
              ? stateVars.GetOemBilgileri[0].oeM_NO
              : null
            : this.state.GetOemBilgileri?.length > 0
            ? this.state.GetOemBilgileri[0].oeM_NO
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetWebStokOem = result?.data.getWebStokOem;

    stateVars.GetStokResim = result?.data.getStokResim;

    stateVars.isComp67122Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokResim !== undefined
            ? stateVars.GetStokResim?.length > 0
              ? stateVars.GetStokResim[0].resim
              : null
            : this.state.GetStokResim?.length > 0
            ? this.state.GetStokResim[0].resim
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp9435Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokResim !== undefined
            ? stateVars.GetStokResim?.length > 0
              ? stateVars.GetStokResim[0].resim
              : null
            : this.state.GetStokResim?.length > 0
            ? this.state.GetStokResim[0].resim
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetFarkliOlcuStok = result?.data.getFarkliOlcuStok;

    stateVars.isComp711881Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetFarkliOlcuStok !== undefined
            ? stateVars.GetFarkliOlcuStok?.length > 0
              ? stateVars.GetFarkliOlcuStok[0].farklI_OLCU_STOGU
              : null
            : this.state.GetFarkliOlcuStok?.length > 0
            ? this.state.GetFarkliOlcuStok[0].farklI_OLCU_STOGU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.prooductDetailPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  prooductDetailPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_67122 =
      stateVars.GetStokResim ?? this.state.GetStokResim;
    stateVars.isComp67122Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokResim !== undefined
            ? stateVars.GetStokResim?.length > 0
              ? stateVars.GetStokResim[0].resim
              : null
            : this.state.GetStokResim?.length > 0
            ? this.state.GetStokResim[0].resim
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp9435Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokResim !== undefined
            ? stateVars.GetStokResim?.length > 0
              ? stateVars.GetStokResim[0].resim
              : null
            : this.state.GetStokResim?.length > 0
            ? this.state.GetStokResim[0].resim
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.prooductdetail_685473_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].birlesmisstok
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].birlesmisstok
        : null
    );

    formVars.prooductdetail_583835_title = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].adetBazliFiyatAciklama
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].adetBazliFiyatAciklama
        : null
    );

    stateVars.isComp583835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].adetBazliFiyatVarMi
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].adetBazliFiyatVarMi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.prooductdetail_461242_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].stoK_KODU
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].stoK_KODU
        : null
    );

    formVars.prooductdetail_61661_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[
              stateVars.GetStokDetayStokBilgileri.length - 1
            ].barkoD1
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[
            this.state.GetStokDetayStokBilgileri.length - 1
          ].barkoD1
        : null
    );

    stateVars.dataSource_264271 =
      stateVars.GetWebStokOem ?? this.state.GetWebStokOem;
    stateVars.isComp711881Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetFarkliOlcuStok !== undefined
            ? stateVars.GetFarkliOlcuStok?.length > 0
              ? stateVars.GetFarkliOlcuStok[0].farklI_OLCU_STOGU
              : null
            : this.state.GetFarkliOlcuStok?.length > 0
            ? this.state.GetFarkliOlcuStok[0].farklI_OLCU_STOGU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_102381 =
      stateVars.GetFarkliOlcuStok ?? this.state.GetFarkliOlcuStok;
    formVars.prooductdetail_651857_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStokDetayStokBilgileri !== undefined
        ? stateVars.GetStokDetayStokBilgileri?.length > 0
          ? stateVars.GetStokDetayStokBilgileri[0].fiyat
          : null
        : this.state.GetStokDetayStokBilgileri?.length > 0
        ? this.state.GetStokDetayStokBilgileri[0].fiyat
        : null
    );

    stateVars.isComp721927Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp536371Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTamirTakim !== undefined
            ? stateVars.GetTamirTakim?.length > 0
              ? stateVars.GetTamirTakim[0].stoK_KODU
              : null
            : this.state.GetTamirTakim?.length > 0
            ? this.state.GetTamirTakim[0].stoK_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_251456 =
      stateVars.GetTamirTakim ?? this.state.GetTamirTakim;

    stateVars.isComp206560Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanildigiUrunler !== undefined
            ? stateVars.GetKullanildigiUrunler?.length > 0
              ? stateVars.GetKullanildigiUrunler[0].stoK_KODU
              : null
            : this.state.GetKullanildigiUrunler?.length > 0
            ? this.state.GetKullanildigiUrunler[0].stoK_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_787969 =
      stateVars.GetKullanildigiUrunler ?? this.state.GetKullanildigiUrunler;

    stateVars.isComp203933Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanildigiAraclar !== undefined
            ? stateVars.GetKullanildigiAraclar?.length > 0
              ? stateVars.GetKullanildigiAraclar[0].marka
              : null
            : this.state.GetKullanildigiAraclar?.length > 0
            ? this.state.GetKullanildigiAraclar[0].marka
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_79661 =
      stateVars.GetKullanildigiAraclar ?? this.state.GetKullanildigiAraclar;
    stateVars.isComp397200Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetAlternatifUrun !== undefined
            ? stateVars.GetAlternatifUrun?.length > 0
              ? stateVars.GetAlternatifUrun[0].anA_URUN
              : null
            : this.state.GetAlternatifUrun?.length > 0
            ? this.state.GetAlternatifUrun[0].anA_URUN
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_196525 =
      stateVars.GetAlternatifUrun ?? this.state.GetAlternatifUrun;

    stateVars.isComp801000Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeknikOzellikler !== undefined
            ? stateVars.GetTeknikOzellikler?.length > 0
              ? stateVars.GetTeknikOzellikler[0].tekniK_ACIKLAMA
              : null
            : this.state.GetTeknikOzellikler?.length > 0
            ? this.state.GetTeknikOzellikler[0].tekniK_ACIKLAMA
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_318215 =
      stateVars.GetTeknikOzellikler ?? this.state.GetTeknikOzellikler;
    stateVars.isComp720155Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetOemBilgileri !== undefined
            ? stateVars.GetOemBilgileri?.length > 0
              ? stateVars.GetOemBilgileri[0].oeM_NO
              : null
            : this.state.GetOemBilgileri?.length > 0
            ? this.state.GetOemBilgileri[0].oeM_NO
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_923301 =
      stateVars.GetOemBilgileri ?? this.state.GetOemBilgileri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  prooductDetailComponent_319766_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "AnaSayfa",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_647404_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "prooductdetail_647404_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_227193_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "prooductdetail_647404_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_231436_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_674422_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_102381_value",
          "farklI_OLCU_STOGU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.listeFiat ?? this.props.screenInputs.listefiat,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiatGrup ?? this.props.screenInputs.fiatgrup,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.paraBirimi ??
          this.props.screenInputs.parabirimi,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "515106",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_721927_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].fiyat
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].fiyat
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].stoK_KODU
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].stoK_KODU
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].kdV_ORANI
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].kdV_ORANI
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].stoK_ADI
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].stoK_ADI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "122056",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_680501_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f1e0fbb8_a55c_ede0_d2a4_398c736091a6_notify",
        this.defaultML,
        "Fiyatı olmayan ürünü sepete ekleyemezsiniz"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("#212121", "string"),
      ReactSystemFunctions.convertToTypeByName("#ffffff", "string"),
      14
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  prooductDetailComponent_680501_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].fiyat
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].fiyat
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].stoK_KODU
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].stoK_KODU
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].kdV_ORANI
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].kdV_ORANI
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].stoK_ADI
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].stoK_ADI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "prooductDetail",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "161263",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  prooductDetailComponent_680501_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokDetayStokBilgileri !== undefined
            ? stateVars.GetStokDetayStokBilgileri?.length > 0
              ? stateVars.GetStokDetayStokBilgileri[0].fiyat
              : null
            : this.state.GetStokDetayStokBilgileri?.length > 0
            ? this.state.GetStokDetayStokBilgileri[0].fiyat
            : null
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.prooductDetailComponent_680501_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.prooductDetailComponent_680501_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_531437_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_251456_value",
          "tT_KODU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.listeFiat ?? this.props.screenInputs.listefiat,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiatGrup ?? this.props.screenInputs.fiatgrup,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.paraBirimi ??
          this.props.screenInputs.parabirimi,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_251456_value",
          "koD_3"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.prooductDetailComponent_531437_onClick1_,
      "prooductDetail",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "146233",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  prooductDetailComponent_531437_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_617138_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_787969_value",
          "stoK_KODU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.listeFiat ?? this.props.screenInputs.listefiat,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiatGrup ?? this.props.screenInputs.fiatgrup,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.paraBirimi ??
          this.props.screenInputs.parabirimi,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_787969_value",
          "koD_3"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.prooductDetailComponent_617138_onClick1_,
      "prooductDetail",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "853774",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  prooductDetailComponent_617138_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_241943_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_196525_value",
          "alternatiF_URUN"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.listeFiat ?? this.props.screenInputs.listefiat,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiatGrup ?? this.props.screenInputs.fiatgrup,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.paraBirimi ??
          this.props.screenInputs.parabirimi,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "prooductdetail_196525_value",
          "koD_3"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.prooductDetailComponent_241943_onClick1_,
      "prooductDetail",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "669607",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  prooductDetailComponent_241943_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_96452_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_309510_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  prooductDetailComponent_220309_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      ,
      515106,
      122056,
      161263,
      146233,
      853774,
      669607,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.prooductDetailPageInit();
    }
    if (diId == 146233) {
      isErrorOccurred = await this.prooductDetailComponent_531437_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 853774) {
      isErrorOccurred = await this.prooductDetailComponent_617138_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 669607) {
      isErrorOccurred = await this.prooductDetailComponent_241943_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
